import React from "react";
import "./QRPayment.css";

const QRPayment = ({
  isLoading,
  email,
  items,
  subtotal,
  shippingCost,
  total,
  qrImageUrl,
}) => {
  const handleDownload = () => {
    try {
      // Validar si el contenido es base64 (solo PNG en este ejemplo)
      const base64Data = qrImageUrl;
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length)
        .fill()
        .map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" });
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "codigo-qr.png";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Error al descargar el QR:", err);
    }
  };

  const isBase64Image =
    qrImageUrl &&
    !qrImageUrl.startsWith("/") &&
    /^[A-Za-z0-9+/=]+$/.test(qrImageUrl);

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({
          title: "Código QR de Pago",
          text: "Escanea este código QR para pagar.",
          url: qrImageUrl,
        });
      } else {
        alert("Compartir no es compatible con este navegador.");
      }
    } catch (error) {
      console.error("Error al compartir:", error);
    }
  };

  return (
    <div className="qr-container">
      <h2 className="titleQR">Código QR-SIMPLE</h2>
      <div className="qr-content-wrapper">
        <div className="transaction-details">
          <h3>Detalles de su Transacción</h3>
          <p>
            <strong>Email:</strong> {email}
          </p>
          <table className="transaction-table">
            <thead>
              <tr>
                <th>Item</th>
                <th>Precio</th>
                <th>Cantidad</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={4}>
                    <div className="skeleton long" />
                    <div className="skeleton medium" /> 
                  </td>
                </tr>
              ) : (
                items.map((item, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>Bs. {item.price.toFixed(2)}</td>
                    <td>{item.quantity}</td>
                    <td>Bs. {(item.price * item.quantity).toFixed(2)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
 
          <div className="totals">
            <p>
              {isLoading ? (
                <span className="skeleton short" />
              ) : (
                <>
                  <strong>Subtotal:</strong> Bs. {subtotal.toFixed(2)}
                </>
              )}
            </p>
            <p>
              {isLoading ? (
                <span className="skeleton short" />
              ) : (
                <>
                  {" "}
                  <strong>Costo de Envío:</strong> Bs. 
                  {shippingCost.toFixed(2)}
                </>
              )}
            </p>
            <p>
              {isLoading ? (
                <span className="skeleton medium" />
              ) : (
                <>
                  {" "}
                  <strong>TOTAL:</strong> Bs. {total.toFixed(2)}
                </>
              )}
            </p>
          </div>
          <div className="footer-note">
            <p>
              <small>
                💬 Puede guardar el QR y realizar el pago durante el día.
              </small>
            </p>
          </div>
        </div>

        <div className="instructions-qr">
          <div className="instructions">
            <ol>
              <li>
                Abra la aplicación móvil de su banco en su teléfono celular
              </li>
              <li>Seleccione la forma de pago QR-SIMPLE.</li>
              <li>
                Capture el siguiente código QR con la cámara de su teléfono.
              </li>
              <li>Espere algunos segundos para que confirmemos su pago.</li>
            </ol>
          </div>
          <div className="qr-section">
            <div>
              <strong>Escanea y paga aquí:</strong>
            </div>
            <img
              src={
                qrImageUrl !== ""
                  ? qrImageUrl === "/img/error-qr.png"
                    ? "/img/error-qr.png"
                    : "data:image/png;base64," + qrImageUrl
                  : "/img/qr-code-loader.gif"
              }
              alt="Código QR"
              className="qr-image"
            />
            {qrImageUrl === "/img/error-qr.png" ? (
              <div>
                <div>
                  {" "}
                  <b>Error intente nuevamente</b>{" "}
                </div>
                <a href="#" className="new-qr">
                  Generar nuevo QR
                </a>
              </div>
            ) : (
              <div className="qr-buttons">
                <button
                  className="btn download"
                  onClick={handleDownload}
                  disabled={!isBase64Image}
                >
                  Descargar QR
                </button>

                <button className="btn share" onClick={handleShare}>
                  Compartir QR
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRPayment;
